import React from "react";
import { Fade } from "react-awesome-reveal";

function SectionTitle({ title1, title2, text, align = "center", dark = false, className = "" }) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";

  return (
    <Fade triggerOnce direction="up" duration={700}>
      <div className={`flex flex-col gap-[15px] ${alignCls} ${className}`}>
        <div className={`flex flex-col gap-[4px] ${align === "center" ? "items-center" : "items-start"}`}>
          <h2 className={`font-42-28 ${dark ? "!text-white" : ""}`}>{title1}</h2>
          {title2 && <h3 className={`font-32-22 ${dark ? "!text-white" : ""}`}>{title2}</h3>}
        </div>
        {text && (
          <p className={`font-16-14 max-w-[434px] ${dark ? "!text-[rgba(255,255,255,0.7)]" : ""}`}>
            {text}
          </p>
        )}
      </div>
    </Fade>
  );
}

export default SectionTitle;
